import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Ranger from "@/pages/Ranger";

export const Route = createFileRoute("/en/about-qbd/projects/ranger")({
  head: () => buildRouteHead("/en/about-qbd/projects/ranger"),
  component: Ranger,
});

